import { ReportType } from '@/api/generatedApi';
import { ReportTypeCard } from '@/components/Report/ReportTypeCard';
import { REPORT_DESCRIPTIONS, REPORT_TITLES } from '@/components/Report/consts';
import { Box, styled, Typography } from '@mui/material';
import {
  ContentCopy as DuplicationIcon,
  TrendingDown as SimplificationIcon,
  Tune as CustomIcon,
} from '@mui/icons-material';

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: '16px',
  marginTop: '32px',
  color: theme.palette.primary.main,
}));

export const GenerateReportsSection = ({
  onSelectReportType,
}: {
  onSelectReportType: (reportType: ReportType) => void;
}) => {
  return (
    <>
      <SectionTitle>Report Types</SectionTitle>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, minmax(260px, 300px))',
            md: 'repeat(3, minmax(260px, 360px))',
          },
          gap: 3,
          marginBottom: '32px',
        }}
      >
        <ReportTypeCard
          icon={<DuplicationIcon />}
          title={REPORT_TITLES[ReportType.DUPLICATION]}
          description={REPORT_DESCRIPTIONS[ReportType.DUPLICATION]}
          onClick={() => onSelectReportType(ReportType.DUPLICATION)}
        />
        <ReportTypeCard
          icon={<SimplificationIcon />}
          title={REPORT_TITLES[ReportType.SIMPLIFICATION]}
          description={REPORT_DESCRIPTIONS[ReportType.SIMPLIFICATION]}
          onClick={() => onSelectReportType(ReportType.SIMPLIFICATION)}
        />
        <ReportTypeCard
          icon={<CustomIcon />}
          title={REPORT_TITLES[ReportType.CUSTOM]}
          description={REPORT_DESCRIPTIONS[ReportType.CUSTOM]}
          onClick={() => onSelectReportType(ReportType.CUSTOM)}
        />
      </Box>
    </>
  );
};
